import { AlertTriangle, CheckCircle2, XCircle } from 'lucide-react'
import { Card } from '@/components/ui/card'

const mistakes = [
  {
    bad: 'Créer des produits sans SKU alors que tu comptes importer plus tard',
    good: 'Définir un SKU stable dès le départ pour fiabiliser imports et mises à jour',
  },
  {
    bad: 'Relancer des clients avec des numéros ou emails mal saisis',
    good: 'Nettoyer les fiches clients avant d’activer les relances automatiques',
  },
  {
    bad: 'Utiliser “Ajustement” pour simuler tous les achats',
    good: 'Réserver les ajustements aux corrections et utiliser les entrées stock pour les réappros',
  },
  {
    bad: 'Créer trop de dépôts et conteneurs dès le début',
    good: 'Commencer simple avec un dépôt principal et quelques zones utiles',
  },
  {
    bad: 'Confondre paiement de facture, dépôt non affecté et avoir client',
    good: 'Bien distinguer encaissement immédiat, crédit disponible et remboursement',
  },
  {
    bad: 'Vouloir activer l’offline ou l’IA avant de stabiliser les données',
    good: 'Fiabiliser d’abord clients, factures, paiements, stock et relances',
  },
]

export default function CommonMistakesSection() {
  return (
    <section className='mx-auto max-w-7xl px-4 py-16'>
      <div className='max-w-3xl'>
        <div className='inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs text-muted-foreground'>
          <AlertTriangle className='h-3.5 w-3.5' />
          Erreurs fréquentes
        </div>

        <h2 className='mt-4 text-3xl font-bold tracking-tight'>
          Les erreurs qui coûtent du temps et de l’argent
        </h2>

        <p className='mt-3 text-muted-foreground'>
          Beaucoup de problèmes ne viennent pas de l’application, mais d’un
          mauvais ordre d’usage ou de données mal saisies. Voilà les pièges les
          plus fréquents à éviter.
        </p>
      </div>

      <div className='mt-10 grid gap-4 md:grid-cols-2'>
        {mistakes.map((item) => (
          <Card key={item.bad} className='p-5'>
            <div className='flex items-start gap-3'>
              <div className='mt-0.5 rounded-full bg-destructive/10 p-2 text-destructive'>
                <XCircle className='h-4 w-4' />
              </div>

              <div className='space-y-3'>
                <div>
                  <div className='text-sm font-semibold'>À éviter</div>
                  <p className='mt-1 text-sm text-muted-foreground'>
                    {item.bad}
                  </p>
                </div>

                <div className='h-px bg-border' />

                <div className='flex items-start gap-3'>
                  <div className='mt-0.5 rounded-full bg-primary/10 p-2 text-primary'>
                    <CheckCircle2 className='h-4 w-4' />
                  </div>
                  <div>
                    <div className='text-sm font-semibold'>
                      À faire à la place
                    </div>
                    <p className='mt-1 text-sm text-muted-foreground'>
                      {item.good}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </section>
  )
}
